import FundingMethodBadge from '@/components/deal/funding-method/funding-method-badge';
import type { FundingMethod } from '@/models/types';
import { COMBO_BOX_OPTIONS } from '../combobox-popovers/all-filters-combobox-popover';
import FundingMethodFiltersComboBoxPopover from '../combobox-popovers/funding-method-filters-combobox-popover';
import {
  type FundingMethodFilterChipProps,
  type FundingMethodFiltersState,
} from '../types';
import BaseFilterChip from './base-filter-chip';

const FundingMethodFilterChip = (props: FundingMethodFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    <BaseFilterChip<FundingMethod, FundingMethodFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={FundingMethodFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS.find((option) => option.value === 'funding_method')
          ?.icon
      }
      filterName="Funding Method"
      filterQuantifier={{
        singular: 'funding method',
        plural: 'funding methods',
      }}
      SelectedFilterBadge={FundingMethodBadge}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
    />
  );
};

export default FundingMethodFilterChip;
